<template>
    <select v-model="claimType">
        <option :value="null">All</option>
        <option value="fatal_accident_estate">Fatal Accident Estate</option>
        <option value="fatal_accident_dependency">Fatal Accident Dependency</option>
        <option value="lost_years">Lost Years</option>
        <option value="personal_injury" v-if="diseaseOrAccident !== 'disease'">Personal Injury</option>
    </select>
</template>

<script>
    import { mapActions, mapGetters, mapMutations, mapState } from 'vuex';
    import Control from 'components/form/Control.vue';

    export default {
        name: 'claim-type',
        components: {
            Control,
        },
        computed: {
            ...mapState('discountRateComparison', {
                getClaimType: 'claimType',
            }),
            claimType: {
                get() {
                    return this.getClaimType;
                },
                set(value) {
                    this.update({ key: 'claimType', value });
                },
            },
            diseaseOrAccident: {
                get() {
                    return this.$store.getters['dashboards/diseaseOrAccident'];
                },
            },
        },
        methods: {
            ...mapActions('discountRateComparison', [
                'update',
            ]),
        },
    }
</script>



// WEBPACK FOOTER //
// ClaimType.vue?fcc84102